(function () {
  document.documentElement.classList.add('js-motion');

  if (window.__vibeeMotionInit) return;
  window.__vibeeMotionInit = true;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      el.classList.add('is-revealed');
    });
    return;
  }

  document.querySelectorAll('[data-reveal-group]').forEach(function (group) {
    var children = group.querySelectorAll(':scope > [data-reveal]');
    children.forEach(function (child, index) {
      if (index > 5) return;
      child.style.transitionDelay = String(index * 60) + 'ms';
    });
  });

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.classList.add('is-revealing', 'is-revealed');
        observer.unobserve(el);
        window.setTimeout(function () {
          el.classList.remove('is-revealing');
        }, 320);
      });
    },
    { rootMargin: '-8% 0px', threshold: 0 },
  );

  function observeReveal(root) {
    root.querySelectorAll('[data-reveal]:not(.is-revealed)').forEach(function (el) {
      observer.observe(el);
    });
  }

  function boot() {
    observeReveal(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) observeReveal(event.target);
  });
})();
